let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

export const useApi = () => {
  const config = useRuntimeConfig()
  const authStore = useAuthStore()
  const baseURL = config.public.apiBase

  const makeRequest = async ({ url, method = 'GET', data = null, params = null, _skipAuth = false, customHeaders = {} }) => {
    const headers = {
      ...customHeaders
    }

    // Usar el token del store (state simple, no computed)
    if (authStore.accessToken && !_skipAuth) {
      headers.Authorization = `Bearer ${authStore.accessToken}`
    }

    const fetchOptions = {
      method,
      headers,
      baseURL,
    }

    if (params) {
      fetchOptions.params = params
    }

    if (data && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(method.toUpperCase())) {
      headers['Content-Type'] = 'application/json'
      fetchOptions.body = data
    }

    try {
      return await $fetch(url, fetchOptions)
    } catch (error) {
      // Si es 401 y hay refresh token, intentar refresh
      if (error.response?.status === 401 && !_skipAuth && authStore.refreshToken) {
        if (isRefreshing) {
          // Esperar a que termine el refresh en curso
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          }).then(async (token) => {
            headers.Authorization = `Bearer ${token}`
            return await $fetch(url, { ...fetchOptions, headers })
          }).catch(queueError => {
            throw queueError
          })
        }

        isRefreshing = true

        try {
          const refreshData = await authStore.refreshAccessToken()
          const newAccessToken = refreshData.accessToken
          processQueue(null, newAccessToken)
          headers.Authorization = `Bearer ${newAccessToken}`
          return await $fetch(url, { ...fetchOptions, headers })
        } catch (refreshError) {
          processQueue(refreshError, null)
          await navigateTo('/login')
          throw refreshError
        } finally {
          isRefreshing = false
        }
      }

      const payload = error.data?.data || error.data || null
      const status = error.response?.status || error.statusCode || 500
      const wrapped = createError({
        statusCode: status,
        statusMessage: error.response?.statusText || error.statusMessage || 'Error',
        message: payload?.message || error.message || 'Error desconocido',
        fatal: false
      })
      // Preserve full server payload (message + validation errors array)
      // so callers can parse field-level validation errors via useValidationErrors
      wrapped.data = payload
      // h3 >= 2 expone `status` como getter (alias de statusCode); asignarlo lanza
      if (wrapped.status !== status) wrapped.status = status
      throw wrapped
    }
  }

  return {
    makeRequest,
  }
}

// Exportar funciones de estado de refresh para compatibilidad
export const getRefreshState = () => isRefreshing
export const setRefreshState = (state) => { isRefreshing = state }
